enum AcomodacaoEnum {
  apartamento = 1,
  enfermaria = 2,
}

export default AcomodacaoEnum
